$('.sidebar__handle').click( function() {
  $('.bloglayout--sidebar').toggleClass('interact--open');
});
